"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ConditionalComponent = _interopRequireDefault(require("../ConditionalComponent/ConditionalComponent"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _generateId = require("../../utils/generateId");
var _function = require("../../utils/type-checks/function");
var _number = require("../../utils/type-checks/number");
var _setCustomError = _interopRequireDefault(require("../../utils/html-input-validation/setCustomError"));
var _react = _interopRequireWildcard(require("react"));
var _string = require("../../utils/type-checks/string");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var FormSelect = function FormSelect(props) {
  var className = props.className,
    disabled = props.disabled,
    label = props.label,
    multiple = props.multiple,
    name = props.name,
    onBlur = props.onBlur,
    onChange = props.onChange,
    onFocus = props.onFocus,
    onValidate = props.onValidate,
    options = props.options,
    required = props.required,
    size = props.size,
    validateOnChange = props.validateOnChange;
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    id = _useState2[0],
    setId = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isFocused = _useState4[0],
    setIsFocused = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isInteractionStarted = _useState6[0],
    setIsInteractionStarted = _useState6[1];
  var _useState7 = (0, _react.useState)(""),
    _useState8 = _slicedToArray(_useState7, 2),
    validationMessage = _useState8[0],
    setValidationMessage = _useState8[1];
  var _useState9 = (0, _react.useState)(null),
    _useState10 = _slicedToArray(_useState9, 2),
    validity = _useState10[0],
    setValidity = _useState10[1];
  var _useState11 = (0, _react.useState)((0, _string.isString)(props.value) ? props.value : ""),
    _useState12 = _slicedToArray(_useState11, 2),
    value = _useState12[0],
    setValue = _useState12[1];
  var componentRef = (0, _react.useRef)(null);
  var inputRef = (0, _react.useRef)(null);
  var cmpClassName = (0, _classnames.default)(_defineProperty({
    "cmp-form-select": true,
    "cmp-form-select--isFocused": isFocused,
    "cmp-form-select--isInvalid": isInteractionStarted && !(validity !== null && validity !== void 0 && validity.valid)
  }, className, (0, _string.isStringOfLength)(className)));
  (0, _react.useEffect)(function () {
    setId((0, _string.isStringOfLength)(props.id) ? props.id : (0, _generateId.generateId)());
  }, [props.id]);
  var handleBlur = function handleBlur(e) {
    setIsInteractionStarted(true);
    setIsFocused(false);
    handleValidation(e.target, e.type);
    (0, _function.isFunction)(onBlur) && onBlur(e, componentRef.current);
    setValidity(inputRef.current.validity);
    setValidationMessage(inputRef.current.validationMessage);
  };
  var handleChange = function handleChange(e) {
    var value = e.target.value;
    setValue(value);
    validateOnChange && setIsInteractionStarted(true);
    handleValidation(e.target, e.type);
    (0, _function.isFunction)(onChange) && onChange(e, componentRef.current);
    validateOnChange && setValidationMessage(inputRef.current.validationMessage);
  };
  var handleFocus = function handleFocus(e) {
    setIsFocused(true);
    (0, _function.isFunction)(onFocus) && onFocus(e, componentRef.current);
  };
  var handleValidation = function handleValidation(eventTarget, eventType) {
    var customHandlerErrorMessage = "";
    var customHandlerValid = true;
    var isBlurEvent = eventType === "blur";
    var isChangeEvent = eventType === "change";
    if ((0, _function.isFunction)(onValidate) && (isBlurEvent || isChangeEvent)) {
      var _onValidate = onValidate(eventTarget, componentRef.current),
        message = _onValidate.message,
        valid = _onValidate.valid;
      customHandlerValid = valid;
      if (!customHandlerValid) {
        customHandlerErrorMessage = message;
      }
    }
    (0, _setCustomError.default)(eventTarget, customHandlerErrorMessage);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: cmpClassName,
    ref: componentRef
  }, /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: id
  }, /*#__PURE__*/_react.default.createElement("span", null, label)), /*#__PURE__*/_react.default.createElement("div", {
    className: "cmp-form-select__input-wrap"
  }, /*#__PURE__*/_react.default.createElement("select", {
    disabled: disabled,
    id: id,
    multiple: multiple,
    name: name,
    onBlur: handleBlur,
    onChange: handleChange,
    onFocus: handleFocus,
    ref: inputRef,
    required: required,
    size: (0, _number.isNumber)(size) && size > 0 ? size : null,
    value: value
  }, options.map(function (option, i) {
    return /*#__PURE__*/_react.default.createElement("option", {
      key: i,
      value: option.value
    }, option.label);
  }))), /*#__PURE__*/_react.default.createElement(_ConditionalComponent.default, {
    condition: isInteractionStarted
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "cmp-form-select__input-validity"
  }, validationMessage)));
};

// Define propTypes;
FormSelect.propTypes = {
  /** String to be added to className */
  className: _propTypes.default.string,
  /** disabled attribute flag for select field */
  disabled: _propTypes.default.bool,
  /** id attribute on select field */
  id: _propTypes.default.string,
  /** label element text */
  label: _propTypes.default.string.isRequired,
  /** flag for multiple selections allowed */
  multiple: _propTypes.default.bool,
  /** name attribute on select field */
  name: _propTypes.default.string,
  /** blur event handler */
  onBlur: _propTypes.default.func,
  /** change event handler */
  onChange: _propTypes.default.func,
  /** focus event handler */
  onFocus: _propTypes.default.func,
  /** validate event handler, returns object with boolean 'valid' property and string 'message' property */
  onValidate: _propTypes.default.func,
  /** options array of objects with label/value properties */
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string.isRequired,
    value: _propTypes.default.string.isRequired
  }).isRequired).isRequired,
  /** required attribute flag for select field */
  required: _propTypes.default.bool,
  /** size attribute on select field */
  size: _propTypes.default.number,
  /** flag for validation on change event */
  validateOnChange: _propTypes.default.bool,
  /** value attribute on input field, providing default value */
  value: _propTypes.default.string
};

// Define defaultProps;
FormSelect.defaultProps = {
  disabled: false,
  validateOnChange: false
};

// Export component as default;
var _default = exports.default = FormSelect;